import escape from "lodash/escape";
import { Coords } from "types/app";
import { wrap } from "./encodeHTML";

export const encodeTracksToGPX = (
  trackPoints: Coords[],
  trackPointsEle: number[] | undefined,
  name: string,
  description?: string,
  links?: string[],
  comment?: string,
  number?: string,
  type?: string,
  source?: string
) => {
  // The elements must be in this order, as defined by the GPX 1.1 schema (trkType)
  const gpxTrackData = ["<trk>"];
  if (name) gpxTrackData.push(`    <name>${wrap(name)}</name>`);
  if (comment) gpxTrackData.push(`    <cmt>${wrap(comment)}</cmt>`);
  if (description) gpxTrackData.push(`    <desc>${wrap(description)}</desc>`);
  if (source) gpxTrackData.push(`    <src>${wrap(source)}</src>`);

  if (links) {
    links.forEach((link) => {
      const escapedLink = escape(link);
      gpxTrackData.push(`    <link href="${escapedLink}"></link>`);
    });
  }
  if (number) gpxTrackData.push(`    <number>${wrap(number)}</number>`);
  if (type) gpxTrackData.push(`    <type>${wrap(type)}</type>`);
  gpxTrackData.push("    <trkseg>");
  trackPoints.forEach((trackpoint, index) => {
    const elevation = trackPointsEle?.[index];
    // Points without a known elevation are written without <ele>
    const eleElement = Number.isFinite(elevation)
      ? `<ele>${elevation?.toFixed(4)}</ele>`
      : "";
    gpxTrackData.push(
      `      <trkpt lat="${trackpoint[0]}" lon="${trackpoint[1]}">${eleElement}</trkpt>`
    );
  });
  gpxTrackData.push("    </trkseg>");
  gpxTrackData.push("  </trk>");

  return gpxTrackData.join("\n");
};
